import { DragEndEvent } from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { IBrandPriority } from "../../../../../shared/oversight-core/interfaces/brand-priority";
import ModalContainer, {
  ModelContainerProps,
} from "../../../../../shared/oversight-core/ui-elements/modal-container/modal-container";
import VerticalReorder from "../../../../../shared/oversight-core/ui-elements/vertical-reorder/vertical-reorder";
import { BrandItem } from "../../../../build-system/components/brand-priority-change-modal/components/brand-item/brand-item";

interface IExtendedBrandPriority extends IBrandPriority {
  id: number;
}

interface IProps extends ModelContainerProps {
  brands: IExtendedBrandPriority[];
  setBrands: React.Dispatch<React.SetStateAction<IExtendedBrandPriority[]>>;
}

const UserBrandPriorityChangeModal = (props: IProps) => {
  const { show, onCancel, onClose, onConfirm, brands, setBrands } = props;

  function handleDragEnd(event: DragEndEvent) {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    setBrands((prev) => {
      const from = prev.findIndex((it) => it.id === active.id);
      const to = prev.findIndex((it) => it.id === over.id);
      return from === -1 || to === -1 ? prev : arrayMove(prev, from, to);
    });
  }

  return (
    <>
      <ModalContainer
        show={show}
        onCancel={onCancel}
        onClose={onClose}
        onConfirm={onConfirm}
        isButtonsVisible={false}
      >
        <VerticalReorder onDragEnd={handleDragEnd}>
          <SortableContext
            items={brands.map((brand) => brand.id)}
            strategy={verticalListSortingStrategy}
            disabled
          >
            {brands.map((brand) => {
              return (
                <BrandItem key={brand.id} id={brand.id} brand={brand.brand} />
              );
            })}
          </SortableContext>
        </VerticalReorder>
      </ModalContainer>
    </>
  );
};

export default UserBrandPriorityChangeModal;
